var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAngleRightGray(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 12,
    viewBox: "0 0 7 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M0.769986 11.67C0.559986 11.67 0.349986 11.6 0.209986 11.46C-0.0700138 11.18 -1.39065e-05 10.76 0.279986 10.48L5.24999 6.14001L0.279986 1.66001C-1.39065e-05 1.38001 -0.0700138 0.960011 0.209986 0.680011C0.489986 0.400011 0.909986 0.33001 1.18999 0.61001L6.78999 5.51001C6.92999 5.65001 6.99999 5.86001 6.99999 6.07001C6.99999 6.28001 6.92999 6.49001 6.78999 6.63001L1.18999 11.53C1.04999 11.6 0.909986 11.67 0.769986 11.67Z",
    fill: "#898B94"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAngleRightGray);
export default __webpack_public_path__ + "static/media/angle-right-gray.c52a39f93807b0c81e36b4668771c870.svg";
export { ForwardRef as ReactComponent };